import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Utilize our blockchain
            <br />
            expertise to create
            <br />
            your own NFT platform
          </>
        }
        description={
          <>
            End-to-end non-fungible token marketplace development with a
            <b> world-class</b> team
          </>
        }
        buttonLink="/contact"
        buttonText="Book a free consultation"
        gradient="green"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            Rumble Fish’s talented team stays on top of what’s new in blockchain
            technology.
            <br />
            We’re not only able to develop digital products of the highest
            quality but also proactively consult and recommend the best
            solutions to use in a project.
            <br />
            Our non-fungible tokens (NFTs) platform development expertise allows
            us to be at the forefront of this highly lucrative market.
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
